export class InventoryVault {
    'id';
    'name';
    'region';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InventoryVault.attributeTypeMap;
    }
    constructor() {
    }
}
